import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import FileField from "../../Shared/FileField"
import { InputField } from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"

const ImportLocationForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [zoneOptions, setZoneOptions] = useState([])
    const [villageOptions, setVillageptions] = useState([])
    const [lineOptions, setLineptions] = useState([])
    const [stationOptions, setStationOptions] = useState([])
    const [rateOptions, setRateOptions] = useState([])
    const [formData, setFormData] = useState({
        zone_id: "",
        village_id: "",
        line_id: "",
        station_id: "",
        rate_id: "",
        file: "",
        date: new Date().toISOString().slice(0, 10)
    })

    const {zone_id, village_id, line_id, station_id, rate_id, file, date} = formData

    const navigate = useNavigate()
    
    useEffect(() => {
        
        getSelectOptions()
    }, [])

    const getSelectOptions = async () => {
        setIsLoading(true)
        try {
            const villages_response = await Server.get('/villages/')
            const stations_response = await Server.get('/stations/')
            const rates_response = await Server.get('/rates/')
            
            const zones = [{public_id: '', id: "", name: '-- Please choose zone --'}]
            const villages = [{public_id: '', id: "", name: '-- Please choose village --'}]
            const lines = [{public_id: '', id: "", name: '-- Please choose line --'}]
            const stations = [{public_id: '', id: "", name: '-- Please choose station --'}]
            const rates = [{public_id: '', id: "", name: '-- Please choose rate --'}]
            

            villages_response.data.map(village => (
                villages.push({
                    id: village.id,
                    public_id: village.public_id,
                    name: village.name
                })
            ))

            stations_response.data.map(station => (
                stations.push({
                    id: station.id,
                    public_id: station.public_id,
                    name: station.name
                })
            ))

            rates_response.data.map(rate => (
                rates.push({
                    id: rate.id,
                    public_id: rate.public_id,
                    name: rate.name
                })
            ))

            setZoneOptions(zones)
            setVillageptions(villages)
            setLineptions(lines)
            setStationOptions(stations)
            setRateOptions(rates)
            setIsLoading(false) 
        } catch (error) {
            setIsLoading(false)

            setZoneOptions([])
            setVillageptions([])
            setLineptions([])
            setStationOptions([])
            setRateOptions([])
        }
    }

    const onChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))

        // change zoneOptions when village is selected
        if (e.target.name === 'village_id'){
            Server.get(`/villages/${e.target.value}/zones`).then(function(response){
                if (response.status === 200){
                    const zones = [{public_id: '', id: "", name: '-- Please choose zone --'}]
                    response.data.map(zone => (
                        zones.push({
                            id: zone.id,
                            public_id: zone.public_id,
                            name: zone.name
                        })
                    ))
                    setZoneOptions(zones)
                }
            })
        }

        // change lineOptions when station is selected
        if (e.target.name === 'station_id'){
            Server.get(`/stations/${e.target.value}/lines`).then(function(response){
                if (response.status === 200){
                    const lines = [{public_id: '', id: "", name: '-- Please choose line --'}]
                    response.data.map(line => (
                        lines.push({
                            id: line.id,
                            public_id: line.public_id,
                            name: line.name
                        })
                    ))
                    setLineptions(lines)
                }
            })
        }
    }

    const onFileChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            file: e.target.files[0]
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()
        const payload = {zone_id, line_id, rate_id, date, file}
        ImportLocation(payload)
    }
    
    // add location
    const ImportLocation = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/locations/import',payload, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            if (response.status === 201){
                toast.success(response?.data?.detail)
                navigate('/locations')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422){
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.warning(error.response.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Import Location Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <SelectField
                                name="village_id"
                                label="Village"
                                value={parseInt(village_id)}
                                options={villageOptions}
                                onChange={onChange}
                                error={errors.village_id}
                            />
                        </div> 
                        <div className="col-md-3">
                            <SelectField
                                name="zone_id"
                                label="Zone"
                                value={parseInt(zone_id)}
                                options={zoneOptions}
                                onChange={onChange}
                                error={errors.zone_id}
                            />
                        </div> 
                        <div className="col-md-3">
                            <SelectField
                                name="station_id"
                                label="Station"
                                value={parseInt(station_id)}
                                options={stationOptions}
                                onChange={onChange}
                                error={errors.station_id}
                            />
                        </div> 
                        <div className="col-md-3">
                            <SelectField
                                name="line_id"
                                label="Line"
                                value={parseInt(line_id)}
                                options={lineOptions}
                                onChange={onChange}
                                error={errors.line_id}
                            />
                        </div> 
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <SelectField
                                name="rate_id"
                                label="Rate"
                                value={parseInt(rate_id)}
                                options={rateOptions}
                                onChange={onChange}
                                error={errors.rate_id}
                            />
                        </div> 
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-4">
                            <FileField
                                name="file"
                                type="file"
                                label="File(Only Excel)"
                                onChange={onFileChange}
                                error={errors.file}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Import" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default ImportLocationForm
